/* global google */
// eslint-disable-next-line import/no-unresolved
import Swiper from 'swiper';
// eslint-disable-next-line import/no-unresolved
import { Navigation } from 'swiper/modules';
import { updateCurrentSlide } from '../functions.js';

function initMap($el) {
  const mapStyles = [
    // Custom styles for map appearance
    {
      featureType: 'administrative',
      elementType: 'all',
      stylers: [{ saturation: '-100' }],
    },
    {
      featureType: 'administrative.province',
      elementType: 'all',
      stylers: [{ visibility: 'off' }],
    },
    {
      featureType: 'landscape',
      elementType: 'all',
      stylers: [{ saturation: -100 }, { lightness: 65 }, { visibility: 'on' }],
    },
    {
      featureType: 'poi',
      elementType: 'all',
      stylers: [{ saturation: -100 }, { lightness: '50' }, { visibility: 'simplified' }],
    },
    {
      featureType: 'road',
      elementType: 'all',
      stylers: [{ saturation: '-100' }],
    },
    {
      featureType: 'road.highway',
      elementType: 'all',
      stylers: [{ visibility: 'simplified' }],
    },
    {
      featureType: 'road.arterial',
      elementType: 'all',
      stylers: [{ lightness: '30' }],
    },
    {
      featureType: 'road.local',
      elementType: 'all',
      stylers: [{ lightness: '40' }],
    },
    {
      featureType: 'transit',
      elementType: 'all',
      stylers: [{ saturation: -100 }, { visibility: 'simplified' }],
    },
    {
      featureType: 'water',
      elementType: 'geometry',
      stylers: [{ hue: '#ffff00' }, { lightness: -25 }, { saturation: -97 }],
    },
    {
      featureType: 'water',
      elementType: 'labels',
      stylers: [{ lightness: -25 }, { saturation: -100 }],
    },
  ];

  // Find all markers inside the map container
  const $markers = $el.find('.marker');

  // Map initialization options
  const mapArgs = {
    zoom: $el.data('zoom') || 16,
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    styles: mapStyles,
    zoomControl: true,
    mapTypeControl: false,
    fullscreenControl: false,
    zoomControlOptions: {
      position: google.maps.ControlPosition.LEFT_BOTTOM,
    },
  };

  // Create the Google Map instance
  const map = new google.maps.Map($el[0], mapArgs);

  // Initialize markers array to keep track of all markers on the map
  map.markers = [];

  // Initialize each marker
  $markers.each(function () {
    initMarker($(this), map);
  });

  // Center and zoom the map to fit all markers
  centerMap(map);

  return map;
}

function initMarker($marker, map) {
  // Extract marker data from HTML attributes
  const lat = $marker.data('lat');
  const lng = $marker.data('lng');
  const slideIdx = $marker.data('marker-id');

  const latLng = {
    lat: parseFloat(lat),
    lng: parseFloat(lng),
  };

  const mapDiv = $(map.getDiv());
  const icon = mapDiv.attr('data-marker');
  const iconActive = mapDiv.attr('data-marker-active');

  // Set default marker options
  const markerOptions = {
    position: latLng,
    map: map,
    icon: icon,
    slideId: slideIdx,
    zIndex: 1,
  };

  // Highlight the first marker by default
  if (slideIdx === 0) {
    markerOptions.icon = iconActive;
    markerOptions.zIndex = 2;
  }

  // Create the Google Maps Marker instance
  const marker = new google.maps.Marker(markerOptions);

  // Save marker for future reference
  map.markers.push(marker);
}

// Function to center the map based on all markers
function centerMap(map) {
  const bounds = new google.maps.LatLngBounds();

  // Extend bounds to include all marker positions
  $.each(map.markers, function (i, marker) {
    const latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());
    bounds.extend(latlng);
  });

  // If only one marker, center the map there; otherwise, fit bounds
  if (map.markers.length === 1) {
    map.setCenter(bounds.getCenter());
  } else {
    map.fitBounds(bounds);
  }
}

// Wait until Google Maps API is loaded before initializing
function waitForGoogleMaps(callback) {
  const interval = setInterval(() => {
    if (window.google && window.google.maps) {
      clearInterval(interval);
      callback();
    }
  }, 100);
}

waitForGoogleMaps(() => {
  $('.acf-map').each((idx, item) => {
    const $this = $(item);

    // Initialize the map instance
    const map = initMap($this);

    // Find the slider wrapper adjacent to the map
    const $sliderWrapper = $this.next('.location-map-slider-wrapper');

    if ($sliderWrapper.length) {
      // Initialize Swiper slider for the location map slider
      const swiper = new Swiper($sliderWrapper[0], {
        modules: [Navigation],
        slidesPerView: 1,
        spaceBetween: 32,
        loop: true,
        speed: 500,
        navigation: {
          nextEl: $sliderWrapper.find('.swiper-next')[0],
          prevEl: $sliderWrapper.find('.swiper-prev')[0],
        },
        on: {
          slideChange: function () {
            const nextSlide = this.realIndex;
            const nextMarker = map.markers[nextSlide];
            const nextPosition = nextMarker.getPosition();

            // Slightly offset longitude to better center marker on map
            const nextLatLng = {
              lat: nextPosition.lat(),
              lng: nextPosition.lng() + 0.05,
            };

            // Pan map to new marker position
            map.panTo(nextLatLng);

            // Reset all markers to default icon and zIndex
            map.markers.forEach((marker) => {
              marker.setIcon($this.attr('data-marker'));
              marker.setZIndex(1);
            });

            // Set active icon and bring active marker to front
            nextMarker.setIcon($this.attr('data-marker-active'));
            nextMarker.setZIndex(2);

            // Call custom function to update slide indicator (if any)
            updateCurrentSlide(this);
          },
        },
      });

      // Add click event listeners on markers AFTER swiper is initialized
      map.markers.forEach((marker) => {
        google.maps.event.addListener(marker, 'click', function () {
          // Pan map to clicked marker position with slight offset
          const latLng = {
            lat: this.getPosition().lat(),
            lng: this.getPosition().lng() + 0.05,
          };
          map.panTo(latLng);

          // Change swiper slide to the one associated with clicked marker
          swiper.slideTo(this.slideId);

          // Reset all markers to default icon and zIndex
          map.markers.forEach((m) => {
            m.setIcon($this.attr('data-marker'));
            m.setZIndex(1);
          });

          // Set clicked marker to active state visually and on top layer
          marker.setIcon($this.attr('data-marker-active'));
          marker.setZIndex(2);
        });
      });
    }
  });
});
